import React from 'react';
import { EditDialog } from '../../../../components/edit-dialog/edit_dialog';
import Select from 'react-select';
import {
    Button,
    Grid,
    DialogActions,
    DialogTitle,
    ExpansionPanel,
    TextField,
    Typography,
    withStyles,
    DialogContent,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Avatar,
} from 'material-ui';
import classNames from 'classnames';
import { styles } from '../../style/block_section';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import { removeBlankParagraphs } from '../../../../components/helpers/helpers';

class BlockSectionEdit extends React.Component {
    render() {
        let {
            classes,
            onHandleSubmit,
            onHandleClose,
            blocks,
            sectionSettings,
            selectedSectionSettings,
            selectSectionSetting,
        } = this.props;

        const collapsibleSetting = sectionSettings.find(
            setting => setting.machine_name === 'section-collapse'
        );
        const selectedCollapseSetting = selectedSectionSettings.find(
            setting => setting.machine_name === 'section-collapse'
        );
        const selectedCollapseOptionId = selectedCollapseSetting
            ? selectedCollapseSetting.options[0].id : '';

        return (
            <EditDialog
                open={this.props.open}
                classes={{
                    paper: classes.paper,
                    fullWidth: classes.fullWidth,
                }}
            >
                <DialogTitle>Edit Block Section</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Search Block (by type name or title)"
                        value={this.props.searchCriteria}
                        onChange={(ev) => {
                            this.props.onSearchBlocks(
                                ev.target.value,
                                this.props.pageId
                            );
                        }}
                    />
                    <div className={classes.root}>
                        {blocks.map((block) => {
                            return (
                                <ExpansionPanel key={block.id}>
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <Typography className={classes.heading}>
                                            {block.block_type_name}
                                        </Typography>
                                        <Typography
                                            className={classes.secondaryHeading}
                                        >
                                            {block.display_name}
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={11}
                                                className="pbSectionEditorText"
                                                dangerouslySetInnerHTML={{
                                                    __html: removeBlankParagraphs(
                                                        block.body
                                                    ),
                                                }}
                                            />
                                            <Grid
                                                item
                                                xs={1}
                                                style={{ marginTop: '20px' }}
                                            >
                                                <Button
                                                    variant="raised"
                                                    size="small"
                                                    onClick={(ev) => {
                                                        onHandleSubmit(block);
                                                    }}
                                                >
                                                    Use
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className={classes.rowAvatars}>
                                                    {
                                                        block.images.map((image, index) => (
                                                            !image.deleted && (
                                                                < Avatar
                                                                    key={index}
                                                                    src={image.image_preview}
                                                                    className={classNames(
                                                                        classes.avatar,
                                                                        classes.bigAvatar
                                                                    )}
                                                                />
                                                            )
                                                        ))
                                                    }
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            );
                        })}
                    </div>

                    {collapsibleSetting &&
                        <Select
                            style={{ marginTop: '10px' }}
                            name="collapsible-select"
                            value={selectedCollapseOptionId}
                            onChange={selectedOption => selectSectionSetting(selectedOption, collapsibleSetting)}
                            options={collapsibleSetting.options}
                            clearable={false}
                            labelKey={'option'}
                            valueKey={'id'}
                            placeholder="Select Collapsible Type"
                            className="React-select-larger-font"
                    />}
                </DialogContent>

                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                        onClick={(ev) => onHandleSubmit(null)}
                        color="primary"
                        variant="raised"
                    >
                            Done
                    </Button>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleClose(ev)}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </EditDialog>
        );
    }
}

export default withStyles(styles)(BlockSectionEdit);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/block_section_edit.js